import DOMPurify from 'dompurify';

// Si estás usando este archivo en un entorno sólo de navegador (React cliente)
export const sanitize = (dirty: string): string => {
  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: { svg: true },
  });
};
